import { Box, Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-recruit.png";
import tContent from "../../../assets/images/content/bg/content-tablet-recruit.png";
import mContent from "../../../assets/images/content/bg/content-mobile-recruit.png";

import { styled } from "styled-components";
import { ScreenContext } from "../../../components/ScreenProvider";
import { useContext } from "react";

const RecruitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BtnRecruit = styled.button<{ bg: string, color: string }>`
  width: 300px;
  height: 60px;
  background: ${(props) => props.bg};
  color: ${(props) => props.color};
  font-size: 18px;
  border: 1px solid #333333;
  border-radius: 62px;
  margin: 20px 0;
  &:hover {
    background: #969696;
  }

  @media (max-width: 768px) {
    width: 60%;
  }
`;

const Recruit = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  const urlSaramin = "https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=K255bFRkQk0ySjZLTVhjVXVqVThIdz09";
  const urlJobkorea = "https://www.jobkorea.co.kr/Recruit/Co_Read/Recruit/C/tbellhr?ChkDispType=1";
  return (
    <RecruitWrapper>
      <Image 
        src={contents[screen]} 
        w={"100%"} 
        alt="" 
      />
      <Box 
        w={"100%"}
        display={"flex"}
        flexDir={"column"}
        alignItems={"center"}
        mb={"100px"}
      >
        <BtnRecruit bg={"#ffffff"} color={"#333333"} onClick={() => window.open(urlSaramin, '_blank')}>
          사람인 지원하기
        </BtnRecruit>
        <BtnRecruit bg={"#333333"} color={"#ffffff"} onClick={() => window.open(urlJobkorea, '_blank')}>
          잡코리아 지원하기
        </BtnRecruit>
      </Box>
    </RecruitWrapper>
  );
};

export default Recruit;